export default __webpack_public_path__ + "static/media/2015.033763e2.png";